export const OasWebhookTopic = {
    claimCreated: 'claim/created',
    claimFinalized: 'claim/finalized',
    shippingClaimCreated: 'shipping_claim/created',
    shippingClaimFinalized: 'shipping_claim/finalized',
    claimUpdated: 'claim/updated',
    shippingClaimUpdated: 'shipping_claim/updated',
    registrationCreated: 'registration/created',
};
export const OasWebhookHeader = {
    'X-Corso-Webhook-Id': 'X-Corso-Webhook-Id',
    'X-Corso-Webhook-Timestamp': 'X-Corso-Webhook-Timestamp',
    'X-Corso-Signature': 'X-Corso-Signature',
    'X-Corso-Webhook-Topic': 'X-Corso-Webhook-Topic',
    'X-Corso-Api-Version': 'X-Corso-Api-Version',
    'X-Corso-Store-Id': 'X-Corso-Store-Id',
    // exposed for consumption on older platforms, that may not support the newer signature header
    'X-Corso-Signature-SHA-256': 'X-Corso-Signature-SHA-256',
};
//# sourceMappingURL=oasWebhook.js.map